import React from 'react';
import DropDown from '../dropdown';
import { useTextResources } from '../../../language';

const AllowRMSDecisionStatusDropDown = ({ ...props }) => {
  const text = useTextResources();
  const sources = [
    {
      value: true,
      text: text('Allowed'),
    },
    {
      value: false,
      text: text('NotAllowed'),
    },
  ];

  return (
    <DropDown
      data={sources}
      placeholder={text('All')}
      valueField='value'
      textField='text'
      nullable
      clearable
      {...props}
    />
  );
};

export default AllowRMSDecisionStatusDropDown;
